var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72989 2.89244V1.8204C5.72989 1.2166 6.2223 0.727127 6.82535 0.727127H8.28557C8.89058 0.727127 9.38104 1.21524 9.38104 1.8204V2.82117C10.0442 3.04008 10.6511 3.38181 11.1747 3.8193L12.016 3.33554C12.541 3.03364 13.2129 3.21361 13.5144 3.73376L14.2445 4.99322C14.547 5.51505 14.3678 6.18214 13.8416 6.48472L13.0321 6.95019C13.0986 7.28986 13.1334 7.64081 13.1334 7.99985C13.1334 8.3589 13.0986 8.70985 13.0321 9.04952L13.8416 9.51499C14.3678 9.81757 14.547 10.4847 14.2445 11.0065L13.5144 12.266C13.2129 12.7861 12.541 12.9661 12.016 12.6642L11.1747 12.1804C10.6511 12.6179 10.0442 12.9596 9.38104 13.1785V14.1793C9.38104 14.7831 8.88863 15.2726 8.28557 15.2726H6.82535C6.22034 15.2726 5.72989 14.7845 5.72989 14.1793V13.1073C5.11132 12.8757 4.54597 12.5358 4.0571 12.1109L3.09492 12.6642C2.56989 12.9661 1.89807 12.7861 1.59654 12.266L0.866428 11.0065C0.563924 10.4847 0.743132 9.81757 1.26935 9.51499L2.26175 8.94435C2.20798 8.63756 2.17994 8.32197 2.17994 7.99985C2.17994 7.67774 2.20798 7.36215 2.26175 7.05536L1.26935 6.48472C0.743132 6.18214 0.563924 5.51505 0.866428 4.99322L1.59654 3.73376C1.89807 3.21361 2.56989 3.03364 3.09492 3.33554L4.0571 3.8888C4.54597 3.46387 5.11132 3.12402 5.72989 2.89244ZM7.55546 9.81804C8.54899 9.81804 9.3544 9.00401 9.3544 7.99985C9.3544 6.9957 8.54899 6.18167 7.55546 6.18167C6.56193 6.18167 5.75652 6.9957 5.75652 7.99985C5.75652 9.00401 6.56193 9.81804 7.55546 9.81804Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1111,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.e5cc44dd.svg";
export { ForwardRef as ReactComponent };